import type { CreateEulaAgreementRequestDTO, LatestEulaResponseDTO } from 'declarations/dto/eula';

import { get, post } from './api';

export const getUsersLatestEulaAgreementStatus: (id: string) => Promise<boolean> = async id => {
  const response = await get<boolean>(`/eula-user-agreements/user/${id}/latest-status`);

  return response.data;
};

export const getLatestEula: () => Promise<LatestEulaResponseDTO> = async () => {
  const response = await get<LatestEulaResponseDTO>(`/eulas/latest`);

  return response.data;
};

export const createNewEulaAgreement: (
  request: CreateEulaAgreementRequestDTO
) => Promise<void> = async request => {
  const response = await post<void, string>(`/eula-user-agreements`, JSON.stringify(request));

  return response.data;
};
